"use client";

import { TextShimmer } from "@/components/text-shimmer";
import { Button } from "@/components/ui/button";
import {
  clearAllHolidayFilters,
  useHolidayFilter,
} from "@/feature/holiday/search/state/extract-holiday-filter-slice";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import { FilterX, RotateCcw } from "lucide-react";
import { HolidayFilterSection } from "./holiday-filter";
import HolidayFilterPopover from "./holiday-filter-popover";

type HolidayFilterSidebarProps = {
  isLoading?: boolean;
};

export function HolidayFilterSidebar({
  isLoading = false,
}: HolidayFilterSidebarProps) {
  const dispatch = useAppDispatch();
  const { hasValue } = useAppSelector(useHolidayFilter);

  return (
    <div className="sticky top-[calc(var(--header-height)+4rem)] z-30 w-full self-start overscroll-none lg:flex lg:h-[calc(100svh-var(--header-height)-4.1rem)] lg:w-5/12 xl:w-[28%]">
      <div className="hidden w-full flex-col lg:flex">
        <div className="z-20 rounded-b-lg border border-t-0 bg-card pt-3">
          <div className="flex items-end justify-between px-4 py-1">
            <span className="text-xs font-bold md:text-lg">
              {isLoading ? (
                <TextShimmer>Searching packages...</TextShimmer>
              ) : (
                "Holiday Search"
              )}
            </span>
          </div>
        </div>

        <div className="mt-3 h-full overflow-auto rounded-t-lg border bg-card no-scrollbar">
          <div className="sticky top-0 z-20 flex items-center justify-between gap-2 border-b bg-card py-2 pl-4">
            <div className="flex items-center gap-2">
              <FilterX className="h-3.5 w-3.5 text-muted-foreground" />
              <span className="font-semibold">Filters</span>
            </div>

            <div className="mr-2 flex items-center gap-1">
              <HolidayFilterPopover />
              {hasValue && (
                <Button
                  type="button"
                  variant="ghost"
                  size="sm"
                  onClick={() => dispatch(clearAllHolidayFilters())}
                >
                  <RotateCcw className="h-3.5 w-3.5" />
                  Reset
                </Button>
              )}
            </div>
          </div>
          <HolidayFilterSection />
        </div>
      </div>
    </div>
  );
}
